import { Plugins } from '@leverege/plugin';

// eslint-disable-next-line import/prefer-default-export
export const BlueprintAttributeFormValidatorFactory = Plugins.createFactory('BlueprintAttributeFormValidator', {
  strategy: Plugins.ARGS,
  pluginKey: 'validator'
});